/*
 * BlueStars mega menu — reveals the third level of the desktop dropdown.
 *
 * The Lv2 column scrolls, so its Lv3 lists cannot live inside it (they would be
 * clipped). They are rendered as siblings in the Lv3 column and swapped here as
 * the pointer or keyboard focus moves down the Lv2 list. With the script absent
 * every Lv2 and Lv3 link is still in the DOM and reachable.
 *
 * Mouse hovers use "menu aim" (the technique behind Amazon's mega menu). On its
 * way from a Lv2 item to the open Lv3 list the pointer usually cuts diagonally
 * across the items below, and switching on each of them swapped the list away
 * from under it. While the recent movement points into the triangle between the
 * pointer and the Lv3 list's left edge, the switch is held back and re-checked
 * after a short delay; moving straight along Lv2, or stopping on an item,
 * switches at once. Touch and keyboard focus always switch at once.
 */
(function () {
  var AIM_DELAY = 300; // ms before an item the pointer aimed past is re-checked
  var AIM_TOLERANCE = 75; // px of slack above and below the Lv3 list
  var TRACKED_LOCS = 3; // pointer positions kept to judge the direction

  function slope(a, b) {
    return (b.y - a.y) / (b.x - a.x);
  }

  function setUpPanel(panel) {
    var lv2 = panel.querySelector('.bs-mega-lv2');
    var lv3Lists = panel.querySelectorAll('.bs-mega-lv3');

    if (!lv2 || !lv3Lists.length) return;

    var activeLink = null;
    var pendingLink = null;
    var timer = null;
    var locs = [];
    var lastDelayLoc = null;

    function cancelPending() {
      clearTimeout(timer);
      timer = null;
      pendingLink = null;
    }

    function reset() {
      cancelPending();
      activeLink = null;
      lastDelayLoc = null;

      var active = lv2.querySelectorAll('.bs-mega-link.is-active');
      for (var i = 0; i < active.length; i++) {
        active[i].classList.remove('is-active');
      }
      for (var j = 0; j < lv3Lists.length; j++) {
        lv3Lists[j].hidden = true;
      }
    }

    function activate(link) {
      if (link === activeLink) {
        cancelPending();
        return;
      }

      reset();
      activeLink = link;

      var targetId = link.getAttribute('data-bs-mega-target');
      if (!targetId) return;

      var list = panel.querySelector('#' + targetId);
      if (!list) return;

      link.classList.add('is-active');
      list.hidden = false;
    }

    function trackLoc(event) {
      var last = locs[locs.length - 1];
      if (last && last.x === event.clientX && last.y === event.clientY) return;

      locs.push({ x: event.clientX, y: event.clientY });
      if (locs.length > TRACKED_LOCS) locs.shift();
    }

    function openListRect() {
      var targetId = activeLink && activeLink.getAttribute('data-bs-mega-target');
      var list = targetId && panel.querySelector('#' + targetId);
      return list && !list.hidden ? list.getBoundingClientRect() : null;
    }

    // How long to hold back switching: 0 unless the pointer is heading into
    // the open Lv3 list, which sits to the right of the Lv2 column.
    function aimDelay() {
      var rect = openListRect();
      var loc = locs[locs.length - 1];
      var prev = locs[0];

      if (!rect || !loc || !prev || loc.x >= rect.left) return 0;

      // Just came into the column: there is no direction to judge yet.
      var column = lv2.getBoundingClientRect();
      if (prev.x < column.left || prev.x > column.right || prev.y < column.top || prev.y > column.bottom) {
        return 0;
      }

      // Still where the last delay was granted: the pointer has stopped here.
      if (lastDelayLoc && loc.x === lastDelayLoc.x && loc.y === lastDelayLoc.y) return 0;

      var upper = { x: rect.left, y: rect.top - AIM_TOLERANCE };
      var lower = { x: rect.left, y: rect.bottom + AIM_TOLERANCE };

      if (slope(loc, upper) < slope(prev, upper) && slope(loc, lower) > slope(prev, lower)) {
        lastDelayLoc = loc;
        return AIM_DELAY;
      }

      lastDelayLoc = null;
      return 0;
    }

    function possiblyActivate(link) {
      var delay = aimDelay();

      if (!delay) {
        activate(link);
        return;
      }

      pendingLink = link;
      clearTimeout(timer);
      timer = setTimeout(function () {
        possiblyActivate(pendingLink);
      }, delay);
    }

    panel.addEventListener('pointermove', function (event) {
      if (event.pointerType === 'mouse') trackLoc(event);
    });

    lv2.addEventListener('pointerover', function (event) {
      var link = event.target.closest('.bs-mega-link');
      if (!link) return;

      if (event.pointerType !== 'mouse') {
        activate(link);
        return;
      }

      trackLoc(event);

      if (link === activeLink) {
        cancelPending();
      } else if (link !== pendingLink) {
        possiblyActivate(link);
      }
    });

    // Leaving the column (into the Lv3 list or anywhere else) keeps the list of
    // the item that is open and drops any switch still waiting.
    lv2.addEventListener('pointerleave', cancelPending);

    lv2.addEventListener('focusin', function (event) {
      var link = event.target.closest('.bs-mega-link');
      if (link) activate(link);
    });

    panel.addEventListener('mouseleave', reset);

    // The dropdown itself closes on the nav item, not on the panel.
    var navItem = panel.closest('.navigation-item');
    if (navItem) navItem.addEventListener('mouseleave', reset);
  }

  function init() {
    var panels = document.querySelectorAll('.bs-mega-menu-columns');
    for (var i = 0; i < panels.length; i++) {
      setUpPanel(panels[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
